export const environment = {
  production: true,
  demo: false,
  apiBasePath: location.protocol + '//' + location.hostname + '/admin/api',
  igvBasePath: location.protocol + '//' + location.hostname + '/static/study_data/Genomic/samples',
};
